/** @format */

import * as React from "react";
import { MenuItem, StandardTextFieldProps, TextField } from "@mui/material";

interface DropDownOption<T, R> {
  key: T;
  value: R;
}


interface CommonDropdownProps<T, R> extends StandardTextFieldProps {
  options: Array<DropDownOption<T, R>>;
}

const CommonDropDown = <
  T extends React.Key,
  R extends string | ReadonlyArray<string> | number
>({
  options,
  ...props
}: CommonDropdownProps<T, R>): React.ReactElement => {
  return (
    <TextField
      {...props}
      select
      SelectProps={{
        native: false,
        MenuProps: {
          disablePortal: false,
          style: { zIndex: 9999 },
        },
      }}
      InputLabelProps={{ shrink: true }}
      inputProps={{
        style: { padding: "1% 2%" }
      }}
    >
      {options.map((option: any, index: any) => (
        <MenuItem key={index} value={option.value}>
          {option.key}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default CommonDropDown;
